export const EURO_SCORE = {
  masterTableName: "MC_EURO_SCORE",
  tableName: "MC_EURO_SCORE_DET",
  columnName: "ES_ID",
  columnValue: 0,
  title: "euro-score.euro-score",
  rows: [
    {
      title: "id",
      value: "ID",
    },
    {
      title: "date",
      value: "PROCESS_TIME",
      headerName: "Tarih",
    },
    {
      title: "age_score",
      value: "AGE_SCORE_XNAME",
    },
    {
      title: "gender_score",
      value: "GENDER_SCORE_XNAME",
    },
    {
      title: "lung_disease",
      value: "LUNG_DISEASE_XNAME",
    },
    {
      title: "extracardiac",
      value: "EXTRACARDIAC_XNAME",
    },
    {
      title: "cardiac_operation",
      value: "CARDIAC_OPERATION_XNAME",
    },
    {
      title: "kidney_function",
      value: "KIDNEY_FUNCTION_XNAME",
    },
    {
      title: "kidney_failure",
      value: "KIDNEY_FAILURE_XNAME",
    },
    {
      title: "active_endocardide",
      value: "ACTIVE_ENDOCARDIDE_XNAME",
    },
    {
      title: "critical_preoperative",
      value: "CRITICAL_PREOPERATIVE_XNAME",
    },
    {
      title: "diabetes_mellitus",
      value: "DIABETES_MELLITUS_XNAME",
    },
    {
      title: "lv_disfunction",
      value: "LV_DISFUNCTION_XNAME",
    },
    {
      title: "pulmonary_hypertension",
      value: "PULMONARY_HYPERTENSION_XNAME",
    },
    {
      title: "thoracic_aorta_surgery",
      value: "THORACIC_AORH_SURGERY_XNAME",
    },
    {
      title: "post_mi_vsd",
      value: "POST_MI_VSD_XNAME",
    },
    {
      title: "euro_score",
      value: "EURO_SCORE",
    },
    {
      title: "note",
      value: "NURSE_NOTE",
    },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1 },
    { field: "age_score", headerName: "euro-score.age", flex: 1 },
    { field: "gender_score", headerName: "euro-score.gender", flex: 1 },
    { field: "lung_disease", headerName: "euro-score.lung-disease", flex: 1 },
    { field: "extracardiac", headerName: "euro-score.extracardiac", flex: 1 },
    {
      field: "cardiac_operation",
      headerName: "euro-score.cardiac-operation",
      flex: 1,
    },
    {
      field: "kidney_function",
      headerName: "euro-score.kidney-function",
      flex: 1,
    },
    {
      field: "kidney_failure",
      headerName: "euro-score.kidney-failure",
      flex: 1,
    },
    {
      field: "active_endocardide",
      headerName: "euro-score.active-endocardide",
      flex: 1,
    },
    {
      field: "critical_preoperative",
      headerName: "euro-score.critical-preoperative",
      flex: 1,
    },
    {
      field: "diabetes_mellitus",
      headerName: "euro-score.diabetes-mellitus",
      flex: 1,
    },
    {
      field: "lv_disfunction",
      headerName: "euro-score.lv-disfunction",
      flex: 1,
    },
    {
      field: "pulmonary_hypertension",
      headerName: "euro-score.pulmonary-hypertension",
      flex: 1,
    },
    {
      field: "thoracic_aorta_surgery",
      headerName: "euro-score.thoracic-aorta-surgery",
      flex: 1,
    },
    { field: "post_mi_vsd", headerName: "euro-score.post-mi-vsd", flex: 1 },
    {
      field: "euro_score",
      headerName: "score",
      flex: 1,
      computed: true,
      calculate: (row: any) => {
        const ageScore = Number(row.AGE_SCORE_XVALUE) || 0;
        const genderScore = Number(row.GENDER_SCORE_XVALUE) || 0;
        const lungDiseaseScore = Number(row.LUNG_DISEASE_XVALUE) || 0;
        const extracardiacScore = Number(row.EXTRACARDIAC_XVALUE) || 0;
        const cardiacOperationScore =
          Number(row.CARDIAC_OPERATION_XVALUE) || 0;
        const kidneyFunctionScore = Number(row.KIDNEY_FUNCTION_XVALUE) || 0;
        const kidneyFailureScore = Number(row.KIDNEY_FAILURE_XVALUE) || 0;
        const activeEndocardideScore =
          Number(row.ACTIVE_ENDOCARDIDE_XVALUE) || 0;
        const criticalPreoperativeScore =
          Number(row.CRITICAL_PREOPERATIVE_XVALUE) || 0;
        const diabetesMellitusScore =
          Number(row.DIABETES_MELLITUS_XVALUE) || 0;
        const lvDisfunctionScore = Number(row.LV_DISFUNCTION_XVALUE) || 0;
        const pulmonaryHypertensionScore =
          Number(row.PULMONARY_HYPERTENSION_XVALUE) || 0;
        const thoracicAortaSurgeryScore =
          Number(row.THORACIC_AORH_SURGERY_XVALUE) || 0;
        const postMiVsdScore = Number(row.POST_MI_VSD_XVALUE) || 0;
        return (
          ageScore +
          genderScore +
          lungDiseaseScore +
          extracardiacScore +
          cardiacOperationScore +
          kidneyFunctionScore +
          kidneyFailureScore +
          activeEndocardideScore +
          criticalPreoperativeScore +
          diabetesMellitusScore +
          lvDisfunctionScore +
          pulmonaryHypertensionScore +
          thoracicAortaSurgeryScore +
          postMiVsdScore
        );
      },
    },
    { field: "note", headerName: "note", flex: 1 },
  ],
  mcpConfig: {
    AGE_SCORE: { mcpId: 300, field: "AGE_SCORE", scoreField: "AGE_SCORE" },
    GENDER_SCORE: {
      mcpId: 301,
      field: "GENDER_SCORE",
      scoreField: "GENDER_SCORE",
    },
    LUNG_DISEASE: {
      mcpId: 302,
      field: "LUNG_DISEASE",
      scoreField: "LUNG_DISEASE",
    },
    EXTRACARDIAC: {
      mcpId: 303,
      field: "EXTRACARDIAC",
      scoreField: "EXTRACARDIAC",
    },
    CARDIAC_OPERATION: {
      mcpId: 304,
      field: "CARDIAC_OPERATION",
      scoreField: "CARDIAC_OPERATION",
    },
    KIDNEY_FUNCTION: {
      mcpId: 305,
      field: "KIDNEY_FUNCTION",
      scoreField: "KIDNEY_FUNCTION",
    },
    KIDNEY_FAILURE: {
      mcpId: 306,
      field: "KIDNEY_FAILURE",
      scoreField: "KIDNEY_FAILURE",
    },
    ACTIVE_ENDOCARDIDE: {
      mcpId: 307,
      field: "ACTIVE_ENDOCARDIDE",
      scoreField: "ACTIVE_ENDOCARDIDE",
    },
    CRITICAL_PREOPERATIVE: {
      mcpId: 308,
      field: "CRITICAL_PREOPERATIVE",
      scoreField: "CRITICAL_PREOPERATIVE",
    },
    DIABETES_MELLITUS: {
      mcpId: 309,
      field: "DIABETES_MELLITUS",
      scoreField: "DIABETES_MELLITUS",
    },
    LV_DISFUNCTION: {
      mcpId: 310,
      field: "LV_DISFUNCTION",
      scoreField: "LV_DISFUNCTION",
    },
    PULMONARY_HYPERTENSION: {
      mcpId: 311,
      field: "PULMONARY_HYPERTENSION",
      scoreField: "PULMONARY_HYPERTENSION",
    },
    THORACIC_AORH_SURGERY: {
      mcpId: 312,
      field: "THORACIC_AORH_SURGERY",
      scoreField: "THORACIC_AORH_SURGERY",
    },
    POST_MI_VSD: {
      mcpId: 313,
      field: "POST_MI_VSD",
      scoreField: "POST_MI_VSD",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    ES_ID: "",
    PROCESS_TIME: new Date(),
    NURSE_ID: "",
    CTIME: new Date(),
    CUSER: "",
    NURSE_NOTE: "",
    AGE_SCORE: "",
    GENDER_SCORE: "",
    LUNG_DISEASE: "",
    EXTRACARDIAC: "",
    CARDIAC_OPERATION: "",
    KIDNEY_FUNCTION: "",
    KIDNEY_FAILURE: "",
    ACTIVE_ENDOCARDIDE: "",
    CRITICAL_PREOPERATIVE: "",
    DIABETES_MELLITUS: "",
    LV_DISFUNCTION: "",
    PULMONARY_HYPERTENSION: "",
    THORACIC_AORH_SURGERY: "",
    POST_MI_VSD: "",
    RESULT: 0,
  },
  chartScoreField: "EURO_SCORE",
  chartTimeField: "PROCESS_TIME",
};
